import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import i18n from 'i18next';
import React, { useMemo } from 'react';
import { ChangeCityCubePrice } from '../../actions/cities';
import { getCurrentCurrency } from '../../actions/currencies';

const useStyles = makeStyles({
    root: {
        maxWidth: 325,
        marginRight: '7px',
        marginBottom: '7px',
        minHeight: '265px',
        minWidth: '325px',
    },
});

export default function CubePrice({ recivedPrice = null }) {
    const currency = useMemo(() => {
        return getCurrentCurrency();
    }, []);
    const classes = useStyles();
    const [price, setPrice] = React.useState(0);
    const [loading, setLoader] = React.useState(false);

    const hasPrice = +recivedPrice?.avg_price_cube > 0;

    const handleChange = e => {
        const value = e.target.value;
        setPrice(value);
    };

    const handleCubePriceChange = async e => {
        e.preventDefault();
        if (!price) return;
        setLoader(true);
        await ChangeCityCubePrice({
            avg_price_cube: +price <= 0 ? -1 : +price,
        });
        setLoader(false);
        setPrice(0);
    };

    return (
        <Card className={classes.root} elevation={0}>
            <Box p={2} display="flex" flexDirection="column" justifyContent="space-between" height="95%">
                <Typography gutterBottom variant="h5" component="h2">
                    {hasPrice ? i18n.t('finance.cubePriceEdit') : i18n.t('finance.cubePriceSet')}
                </Typography>
                <Box>
                    {hasPrice && (
                        <Typography
                            gutterBottom
                            variant="h6"
                            component="h6"
                            style={{ fontSize: '14px', marginBottom: '15px' }}
                        >
                            {`${i18n.t('payments.current_price')}: `}
                            <span className="cityPrice ok">
                                {recivedPrice?.avg_price_cube} {currency}
                            </span>
                        </Typography>
                    )}

                    <form onSubmit={handleCubePriceChange}>
                        <CardActions
                            style={{
                                padding: '0px',
                                marginTop: '15px',
                                marginBottom: '15px',
                            }}
                        >
                            <TextField
                                fullWidth
                                type="number"
                                disabled={loading}
                                className="cityPriceChange"
                                value={price || ''}
                                onChange={handleChange}
                                name="price"
                                variant="outlined"
                                label={`${i18n.t('table.price')} ${currency}`}
                            />
                        </CardActions>
                        <Button
                            fullWidth
                            style={{
                                margin: '0!important',
                                marginTop: '20px!important',
                                color: '#fff',
                            }}
                            size="medium"
                            disabled={loading || !price}
                            className={'bossButton'}
                            onClick={handleCubePriceChange}
                        >
                            {loading ? <CircularProgress color="inherit" size={20} /> : i18n.t('buttons.save')}
                        </Button>
                    </form>
                </Box>
            </Box>
        </Card>
    );
}
